import { render, staticRenderFns } from "./stop1.vue?vue&type=template&id=5d13a1ec&scoped=true"
import script from "./stop1.vue?vue&type=script&lang=js"
export * from "./stop1.vue?vue&type=script&lang=js"
import style0 from "./stop1.vue?vue&type=style&index=0&id=5d13a1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13a1ec",
  null
  
)

export default component.exports